import type { PullRequestMergeMethod } from "@afar-research/contracts";

/**
 * Orders the methods a repository allows so the user's default comes first.
 *
 * The lifecycle form offers the first action as its primary button, so this is
 * what makes "Default merge method" visible: the preferred method leads, the
 * rest keep the repository's own order. A `null` preference, or one the
 * repository does not allow, leaves that order untouched — the setting never
 * offers a merge GitHub would refuse.
 */
export function orderMergeMethodsByPreference(
  methods: ReadonlyArray<PullRequestMergeMethod>,
  preferred: PullRequestMergeMethod | null,
): ReadonlyArray<PullRequestMergeMethod> {
  if (preferred === null || !methods.includes(preferred)) return methods;
  return [preferred, ...methods.filter((method) => method !== preferred)];
}
